import { AccordionItem, AccordionPanel } from '@chakra-ui/react';
import AddUserLicenceTree from './add/steps/AddUserLicenceTree';
import RingGroupAccordionSectionButton from './RingGroupAccordionSectionButton';

export default function RingGroupLicencesSection({
    catalogue,
    values,
    setFieldValue,
    darkMode,
    panelBg,
    accordionBorderColor,
}) {
    return (
        <AccordionItem
            borderColor={accordionBorderColor}
            mb={2}
            borderWidth="1px"
            borderRadius="md"
            overflow="hidden">
            <RingGroupAccordionSectionButton darkMode={darkMode}>
                Licences
            </RingGroupAccordionSectionButton>
            <AccordionPanel px={4} py={4} bg={panelBg}>
                <AddUserLicenceTree
                    catalogue={catalogue}
                    value={values.selectedLicenceIds}
                    onChange={(ids) => setFieldValue('selectedLicenceIds', ids)}
                    darkMode={darkMode}
                />
            </AccordionPanel>
        </AccordionItem>
    );
}
